import axios from "axios";

/**
 * Fetches an author by ID from the API and updates parent component state.
 *
 * @param {number|string} id - The author ID to fetch.
 * @param {Function} setData - Callback to update the author data in the parent component.
 *
 * @example
 * fetchAuthor(5, setAuthor);

 */
export function fetchAuthor(id, setData) {
    const API_URL = process.env.NODE_ENV === "development"
        ? "http://localhost:3000/"
        : "https://api.hillerodfrimenighed.dk/";

    async function getData() {

        try {
            const response = await axios.get(`${API_URL}blog/author/${id}`);
            setData(response.data); // Axios automatically parses JSON
        } catch (error) {
            console.error("Error fetching data:", error);
            setData(null); // Ensure data is reset if an error occurs
        }
    }

    getData(); // Call the function immediately
}
